module.exports = __webpack_public_path__ + "static/media/bar.4ab5a33b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/bar.svg
// module id = 1123
// module chunks = 38